import apiClient from '../clienteFebosAPI';

const RESOURCE = '/repositorios';

const fileFromApi = (file) => ({
  ...(file.archivoId && { id: file.archivoId }),
  ...(file.esPublico && { isPublic: file.esPublico === 'S' }),
  ...(file.fechaCreacion && { createdAt: file.fechaCreacion }),
  ...(file.nombre && { name: file.nombre }),
  ...(file.urlDescarga && { downloadUrl: file.urlDescarga }),
});

const repositoryFromApi = (folder) => ({
  ...(folder.carpetaId && { id: folder.carpetaId }),
  ...(folder.nombre && { name: folder.nombre })
});

// REPOSITORIES
// list
export const ioRepositoriesList = () => apiClient.get(
  RESOURCE,
  { operacionId: 'io.ed.repositorios.listar' }
);

// GET
export const ioRepositoriesGet = (repositoryId) => apiClient.get(
    `${RESOURCE}/${repositoryId}`,
    { operacionId: 'io.ed.repositorios.obtener' }
);

// FILES
// list
export const ioFilesList = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/${payload.repositoryId}/archivos?${params}`,
    { operacionId: 'io.ed.archivos.listar' }
  );
};
// get
export const ioEDFilesGet = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}`,
  { operacionId: 'io.ed.archivos.obtener' }
);

export const ioFilesGetParsed = async (repositoryId, fileId) => {
  const { data: { archivo: file } } = await ioEDFilesGet({ repositoryId, fileId });
  return fileFromApi(file);
};

// add
export const ioFilesAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/archivos`,
  payload.file,
  { operacionId: 'io.ed.archivos.agregar' }
);
// update
export const ioFilesUpdate = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.file.archivoId}`,
  payload.file,
  { operacionId: 'io.ed.archivos.actualizar' }
);
// delete
export const ioFilesDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}`,
  { operacionId: 'io.ed.archivos.eliminar' }
);
// ChangeOwner
export const ioFilesChangeOwner = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/propietario`,
  { propietarioNuevo: payload.ownerId },
  { operacionId: 'io.ed.archivo.propietario.asignar' }
);

// FOLDERS
// list
export const ioFoldersList = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/carpetas?path=${payload.path}`,
  { operacionId: 'io.ed.carpetas.listar' }
);
// get
export const ioEDFoldersGet = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}`,
  { operacionId: 'io.ed.carpetas.obtener' }
);
export const ioRepositoriesGetParsed = async (repositoryId, folderId) => {
  const { data: { carpeta: folder } } = await ioEDFoldersGet({ repositoryId, folderId });
  return repositoryFromApi(folder);
};
// add
export const ioFoldersAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/carpetas`,
  { nombre: payload.name, carpetaPadreId: payload.parentFolder },
  { operacionId: 'io.ed.carpetas.agregar' }
);
// update
export const ioFoldersUpdate = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}`,
  { nombre: payload.name, carpetaPadreId: payload.parentFolder },
  { operacionId: 'io.ed.carpetas.actualizar' }
);
// bloquear carpeta
export const ioFoldersBlock = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/bloqueo`,
  { bloquear: payload.bloqueada },
  { operacionId: 'io.ed.carpetas.bloquear' }
);
export const ioFoldersTemplate = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/templates`,
  { template: payload.template },
  { operacionId: 'io.ed.carpetas.template' }
);
// delete
export const ioFoldersDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}`,
  { operacionId: 'io.ed.carpetas.eliminar' }
);
// ChangeOwner
export const ioFoldersChangeOwner = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/propietario`,
  { propietarioNuevo: payload.ownerId },
  { operacionId: 'io.ed.carpeta.propietario.asignar' }
);

// FILE TAGS
// list (todas los tags de una empresa)
export const ioEDFilesTagsList = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/tags?${params}`, { operacionId: 'io.ed.archivos.tags.listar' });
};
// add
export const ioEDFilesTagsAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/tags`,
  { tags: [payload.tag] },
  { operacionId: 'io.ed.archivos.tags.agregar' }
);
// delete
export const ioEDFilesTagsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/tags?tag=${payload.tag}`,
  { operacionId: 'io.ed.archivos.tags.eliminar' }
);

// FOLDER TAGS
// add
export const ioEDFoldersTagsAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/tags`,
  { tags: [payload.tag] },
  { operacionId: 'io.ed.carpetas.tags.agregar' }
);
// delete
export const ioEDFoldersTagsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/tags?tag=${payload.tag}`,
  { operacionId: 'io.ed.carpetas.tags.eliminar' }
);

// EVALUATIONS
// list
export const ioFilesEvaluationsList = (payload, repositoryId, fileId) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(
    `${RESOURCE}/${repositoryId}/archivos/${fileId}/evaluaciones?${params}`,
    { operacionId: 'io.ed.archivos.evaluaciones.listar' }
  );
};
// add
export const ioFilesEvaluationsAdd = (repositoryId, fileId, evaluation) => apiClient.post(
  `${RESOURCE}/${repositoryId}/archivos/${fileId}/evaluaciones?evaluacion=${evaluation}`,
  { evaluacion: evaluation },
  { operacionId: 'io.ed.archivos.evaluaciones.agregar' }
);
// update
export const ioFilesEvaluationsUpdate = (repositoryId, fileId, evaluation) => apiClient.put(
  `${RESOURCE}/${repositoryId}/archivos/${fileId}/evaluaciones?evaluacion=${evaluation}`,
  { evaluacion: evaluation },
  { operacionId: 'io.ed.archivos.evaluaciones.actualizar' }
);

// KEYWORDS
// list (no esta en el xls)
export const ioEDFilesKeywordsList = (payload) => apiClient.get(
    `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/keywords`,
    { operacionId: 'io.ed.archivos.keywords.listar' }
);
// add
export const ioEDFilesKeywordsAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/keywords`,
  { keywords: [payload.keyword] },
  { operacionId: 'io.ed.archivos.keywords.agregar' }
);
// delete
export const ioEDFilesKeywordsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/keywords?keywords=${payload.keywords}`,
  { operacionId: 'io.ed.archivos.keywords.eliminar' }
);

// FILE SUBSCRIPTIONS
// list
export const ioEDFileSubscriptionsList = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/suscripciones?${params}`,
    { operacionId: 'io.ed.archivos.suscripciones.listar' }
  );
};
// add
export const ioEDFileSubscriptionsAdd = (payload) => {
  if (payload.subscriberId) {
    const body = {
      usuarioSuscrito: payload.subscriberId,
      suscripcionDesde: payload.fromDate,
    };
    if (payload.toDate) {
      body.suscripcionHasta = payload.toDate;
    }
    return apiClient.post(
      `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/suscripciones`,
      body,
      { operacionId: 'io.ed.archivos.suscripciones.agregar' }
    );
  }
  return apiClient.post(
    `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/suscripciones`,
    { operacionId: 'io.ed.archivos.suscripciones.agregar' }
  );
};
// delete
export const ioEDFileSubscriptionsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/suscripciones/${payload.subscriptionId}`,
  { operacionId: 'io.ed.archivos.suscripciones.eliminar' }
);

// FOLDER SUBSCRIPTIONS
// list
export const ioEDFoldersSubscriptionsList = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/suscripciones?${params}`,
    { operacionId: 'io.ed.carpetas.suscripciones.listar' }
  );
};
// add
export const ioEDFoldersSubscriptionsAdd = (payload) => {
  if (payload.subscriberId) {
    const body = {
      usuarioSuscrito: payload.subscriberId,
      suscripcionDesde: payload.fromDate,
    };
    if (payload.toDate) {
      body.suscripcionHasta = payload.toDate;
    }
    return apiClient.post(
      `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/suscripciones`,
      body,
      { operacionId: 'io.ed.carpetas.suscripciones.agregar' }
    );
  }
  return apiClient.post(
    `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/suscripciones`,
    { operacionId: 'io.ed.carpetas.suscripciones.agregar' }
  );
};
// delete
export const ioEDFoldersSubscriptionsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.folderId}/suscripciones/${payload.subscriptionId}`,
  { operacionId: 'io.ed.carpetas.suscripciones.eliminar' }
);

// EVALUATIONS
// list
export const ioEDEvaluationsList = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/evaluaciones`,
  { operacionId: 'io.ed.evaluaciones.listar' }
);
// add
export const ioEDEvaluationsAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/evaluaciones`,
  { evaluacion: payload.evaluation },
  { operacionId: 'io.ed.evaluaciones.agregar' }
);

// PERMISSIONS
// add
export const ioEDPermissionsAdd = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.post(
    `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/permisos?${params}`,
    [{
      referenciaId: payload.referenceId,
      lectura: payload.read,
      escritura: payload.write,
      controlTotal: payload.totalControl,
      referenciaTipo: payload.referenceType
    }],
    { operacionId: 'io.ed.permisos.agregar' }
  );
};
// update
export const ioEDPermissionsUpdate = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.put(
    `${RESOURCE}/${payload.repositoryId}/elementos/`
    + `${payload.elementId}/permisos/${payload.permissionId}?${params}`,
    {
      lectura: payload.read,
      escritura: payload.write,
      controlTotal: payload.totalControl
    },
    { operacionId: 'io.ed.permisos.actualizar' }
  );
};
// list
export const ioEDPermissionsList = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/permisos`,
  { operacionId: 'io.ed.permisos.listar' }
);
// delete
export const ioEDPermissionsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/permisos/${payload.permissionId}`,
  { operacionId: 'io.ed.permisos.eliminar' }
);
// binnacle for files
export const ioEDFilesBinnacle = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.fileId}/bitacoras`,
  { operacionId: 'io.ed.archivos.bitacora' }
);

// binnacle for folders
export const ioEDFoldersBinnacle = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/carpetas/${payload.fileId}/bitacoras`,
  { operacionId: 'io.ed.carpetas.bitacora' }
);
// FILTER
export const ioEDRepositorySearch = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/${payload.repositoryId}/busquedas?${params}`,
    { operacionId: 'io.ed.repositorio.buscar' }
  );
};

// Transaccionality
// get
export const ioEDTransaccionality = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(`${RESOURCE}/transaccionalidad/holding?${params}`,
    { operacionId: 'io.ed.reportes.global.obtener' });
};

// get holding detail
export const ioEDHoldingTransaccionality = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/transaccionalidad/holding/detalle?${params}`
  );
};

// VERSIONS
// list
export const ioEDVersions = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/archivos/${payload.id}/versiones`,
  { operacionId: 'io.ed.archivos.versiones.listar' }
);

// ELEMENTS COMMENTS
// list
export const ioEDElementsCommentsList = (payload) => apiClient.get(
  `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/comentarios?orden=${payload.order}`,
  { operacionId: 'io.ed.comentarios.listar' }
);
// add
export const ioEDElementsCommentsAdd = (payload) => apiClient.post(
  `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/comentarios`,
  { comentario: payload.comment, tipo: payload.type },
  { operacionId: 'io.ed.comentarios.agregar' }
);
// update
export const ioEDElementsCommentsUpdate = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/comentarios/${payload.commentId}`,
  { comentario: payload.comment, tipo: payload.type },
  { operacionId: 'io.ed.comentarios.actualizar' }
);
// delete
export const ioEDElementsCommentsDelete = (payload) => apiClient.delete(
  `${RESOURCE}/${payload.repositoryId}/elementos/${payload.elementId}/comentarios/${payload.commentId}`,
  { data: { tipo: payload.type } },
  { operacionId: 'io.ed.comentarios.eliminar' }
);

// CREATE MAIN REPOSITORY
export const ioEDEditRepository = (payload) => apiClient.put(
  `${RESOURCE}/${payload.repositoryId}`,
  {
    reestablecer: payload.reset,
    nombre: payload.name,
    descripcion: payload.description,
  },
  { operacionId: 'io.ed.repositorio.empresa.agregar' }
);

// EDIT MAIN REPOSITORY
export const ioEDCreateRepository = () => apiClient.post(
  `${RESOURCE}/empresas`,
  { operacionId: 'io.ed.repositorio.empresa.agregar' }
);

export const ioGetCustomFile = (file, params) => {
  const paramsRequest = apiClient.queryParams(params);
  return apiClient.get(
    `/v2/documents/${file.type}/${file.id}?${paramsRequest}`,
    { operacionId: 'io.ed.custom.obtener' }
  );
};
